import { HHStack } from '@hinge-health/react-component-library';
import { FilterChip } from './filter-chip';

export interface ChipFilterOption<TValue extends string> {
  value: TValue;
  label: string;
}

interface ChipFilterProps<TValue extends string> {
  options: ChipFilterOption<TValue>[];
  value: TValue;
  onChange: (value: TValue) => void;
  ariaLabel: string;
  testIdPrefix: string;
}

/** Single-value chip group (exactly one option pressed at a time). */
export const ChipFilter = <TValue extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  testIdPrefix,
}: ChipFilterProps<TValue>): JSX.Element => (
  <HHStack
    direction="row"
    gap={1}
    flexWrap="wrap"
    role="group"
    aria-label={ariaLabel}
  >
    {options.map(option => (
      <FilterChip
        key={option.value}
        label={option.label}
        isPressed={option.value === value}
        onClick={(): void => onChange(option.value)}
        testId={`${testIdPrefix}-${option.value}`}
      />
    ))}
  </HHStack>
);
